import { HttpClient } from "@angular/common/http";
import { Inject, Injectable } from "@angular/core";
import { map, Observable, take } from "rxjs";
import { API_BASE_URL } from "src/app/injection-constants";
import { App } from "../models/app.model";
import { PaggedResponse } from "../models/catalog-paged.response";


@Injectable({
    providedIn: 'root',
})
export class AppSearchService {
    constructor(private readonly http: HttpClient,
        @Inject(API_BASE_URL) private readonly apiBaseUrl: string) { }

    getApps(searchTerm: string): Observable<App[]> {
        const body = {
            filter: {
                searchTerm: searchTerm,
                isSupportMode: true,
                includeHidden: true
            },
            pageSize: 100,
            nextPage: ''
        };

        return this.http.post<PaggedResponse<App>>(`${this.apiBaseUrl}/apps/search`, body)
            .pipe(
                take(1),
                map(result => result.items)
            );
    }

    getAppById(id: string): Observable<App[]> {
        const body = {
            filter: {
                appIds: [id],
                isSupportMode: true,
                includeHidden: true
            },
            pageSize: 1,
            nextPage: ''
        };

        return this.http.post<PaggedResponse<App>>(`${this.apiBaseUrl}/apps/search`, body)
            .pipe(
                take(1),
                map(result => result.items)
            );
    }
}
